const LINE_LENGTH_11 = 11;
const LINE_LENGTH_12 = 12;
const LINE_LENGTH_15 = 15;
const LINE_LENGTH_20 = 20;
const LINE_LENGTH_24 = 24;
const LINE_LENGTH_25 = 25;
const LINE_LENGTH_36 = 36;
const LINE_LENGTH_38 = 38;
const LINE_LENGTH_50 = 50;

const TWO_LINE_HEIGHT = 44;
const THREE_LINE_HEIGHT = 59;
const FOUR_LINE_HEIGHT_SMALLER = 72;
const FOUR_LINE_HEIGHT = 74;
const FIVE_LINE_HEIGHT = 88;

const SINGLE_LINE_HEIGHT_FEATURES = 30;

export const getLineHeightFeaturesDesktop = (lineLength) => {
  if (lineLength < LINE_LENGTH_25) {
    return SINGLE_LINE_HEIGHT_FEATURES;
  } if (lineLength < LINE_LENGTH_50) {
    return TWO_LINE_HEIGHT;
  }
  return THREE_LINE_HEIGHT;
};

export const getLineHeightFeaturesTablet = (lineLength) => {
  if (lineLength < LINE_LENGTH_24) {
    return SINGLE_LINE_HEIGHT_FEATURES;
  } if (lineLength < LINE_LENGTH_38) {
    return TWO_LINE_HEIGHT;
  }
  return THREE_LINE_HEIGHT;
};

export const getLineHeightFeaturesMobile = (lineLength) => {
  if (lineLength < LINE_LENGTH_12) {
    return SINGLE_LINE_HEIGHT_FEATURES;
  } if (lineLength < LINE_LENGTH_15) {
    return TWO_LINE_HEIGHT;
  } if (lineLength < LINE_LENGTH_24) {
    return THREE_LINE_HEIGHT;
  } if (lineLength < LINE_LENGTH_36) {
    return FOUR_LINE_HEIGHT;
  }
  return FIVE_LINE_HEIGHT;
};

export const getLineHeightDesktop = (lineLength) => {
  if (lineLength < LINE_LENGTH_25) {
    return TWO_LINE_HEIGHT;
  } if (lineLength < LINE_LENGTH_50) {
    return THREE_LINE_HEIGHT;
  }
  return FOUR_LINE_HEIGHT_SMALLER;
};

export const getLineHeightTablet = (lineLength) => {
  if (lineLength < LINE_LENGTH_20) {
    return TWO_LINE_HEIGHT;
  } if (lineLength < LINE_LENGTH_38) {
    return THREE_LINE_HEIGHT;
  }
  return FOUR_LINE_HEIGHT_SMALLER;
};

export const getLineHeight1239 = (lineLength) => {
  if (lineLength < LINE_LENGTH_11) {
    return TWO_LINE_HEIGHT;
  } if (lineLength < LINE_LENGTH_38) {
    return THREE_LINE_HEIGHT;
  }
  return FOUR_LINE_HEIGHT_SMALLER;
};

export const getLineHeightMobile = (lineLength) => {
  if (lineLength < LINE_LENGTH_11) {
    return TWO_LINE_HEIGHT;
  } if (lineLength < LINE_LENGTH_24) {
    return THREE_LINE_HEIGHT;
  } if (lineLength < LINE_LENGTH_36) {
    return FOUR_LINE_HEIGHT;
  }
  return FIVE_LINE_HEIGHT;
};
